import { render } from "./PdfViewerDialog.vue?vue&type=template&id=b3e51e1e&scoped=true"
import script from "./PdfViewerDialog.vue?vue&type=script&lang=js"
export * from "./PdfViewerDialog.vue?vue&type=script&lang=js"

import "./PdfViewerDialog.vue?vue&type=style&index=0&id=b3e51e1e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3e51e1e"]])

export default __exports__